import { render, staticRenderFns } from "./SuiteWebForms.vue?vue&type=template&id=769a325b&"
import script from "./SuiteWebForms.vue?vue&type=script&lang=js&"
export * from "./SuiteWebForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports